module.exports = "/_next/static/images/958aa087af53d58198b918c0a4832069-sanpablo-2.jpg";